<div class="grid tk-grid-rows place-items-center h-screen tk-bg-gray-1 tk-i-background">

  <div class="mx-auto flex-1 flex-col place-items-center w-full">

    <div class="mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
    </div>

    <div *ngIf="!isLinkNotActive; else linkNotActiveTemp" class="text-lg font-semibold text-center">
      {{'labels.loading-data.loading' | translate}}
    </div>
    <ng-template #linkNotActiveTemp>
      <div class="grid place-items-center">
        <div id="error-inactive-link" class="text-lg font-semibold text-center">{{'link-login.inactive-link' | translate}}</div>
        <div class="mt-3">{{'link-login.hint' | translate}}</div>
        <div class="mt-3 flex items-center">
          <sm-copy-to-clipboard [data]="url" [isAutoCopy]="true"></sm-copy-to-clipboard>
          <span class="ml-1 tk-c-gray-9">{{url}}</span>
        </div>
      </div>
    </ng-template>

  </div>

  <am-login-footer class="mb-8 w-full" [isLanguageSwitchVisible]="isLinkNotActive"></am-login-footer>
</div>
